import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GenericIndexCardStackBackgroundViewModel } from './generic-index-card-stack-background-view-model';
import type { GenericCardData } from '../../../../../../../models/print-cards/generic-card-data';

@Component({
  selector: 'app-generic-index-card-stack-background',
  templateUrl: './generic-index-card-stack-background.component.html',
  styleUrls: ['./generic-index-card-stack-background.component.scss'],
  providers: [GenericIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericIndexCardStackBackgroundComponent extends CardBackgroundComponent implements AfterViewInit {
  constructor(
    public viewModel: GenericIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GenericCardData;
}
